
const BillingBlock = () => {

    const querySelector = {
        promoButtons: document.querySelectorAll('.billing-block .buttons-promo a'),
        billingDataPrices: document.querySelectorAll('.billing-data .pricing'),
    }

    const handlePromoButtonClick = (promoButton, index) => {
        console.log('evt > ', promoButton)

        querySelector.promoButtons.forEach((promoButton) => {
            promoButton.classList.remove('btn-active')
            promoButton.classList.add('btn-inactive')
        })

        promoButton.classList.remove('btn-inactive')
        promoButton.classList.add('btn-active')

        querySelector.billingDataPrices.forEach((billingDataPrice) => {
            billingDataPrice.classList.remove('active')
        });

        querySelector.billingDataPrices[index].classList.add('active');
    }

    const setupListeners = () => {
        querySelector.promoButtons.forEach((promoButton, index) => {
            promoButton.addEventListener('click', (e) => { e.preventDefault(); handlePromoButtonClick(promoButton, index) });
        });
    }

    return {
        init: () => {
            setupListeners();
        },
    }

}

export default BillingBlock().init;
